import { Card, CardContent, CardHeader } from '@r/components/ui/card.tsx';
import { Skeleton } from '@ui/skeleton.tsx';

export function OrderDetailContentSkeleton() {
  return (
    <div className="space-y-6">
      {/* OrderProductsTableCard skeleton */}
      <Card className="w-full overflow-hidden">
        <CardHeader className="px-0 pt-0">
          <Card className="grid grid-cols-12 overflow-hidden h-fit rounded-none border-0 border-b">
            <div className="aspect-square sm:aspect-auto col-span-12 sm:col-span-5 xl:col-span-3 overflow-hidden">
              <Skeleton className="w-full h-full min-h-[160px] rounded-none" />
            </div>
            <div className="col-span-12 sm:col-span-7 xl:col-span-9 p-6 grid grid-cols-12 gap-5">
              {[...Array(6)].map((_, i) => (
                <div
                  key={i}
                  className="flex flex-col gap-1 col-span-12 md:col-span-6 xl:col-span-6"
                >
                  <Skeleton className="h-3 w-20" />
                  <Skeleton className="h-5 w-36" />
                </div>
              ))}
            </div>
          </Card>
        </CardHeader>
        <CardContent className="p-6 pt-0 space-y-3">
          <div className="grid grid-cols-5 gap-4">
            {[...Array(5)].map((_, i) => (
              <Skeleton key={i} className="h-4" />
            ))}
          </div>
          {[...Array(3)].map((_, i) => (
            <div key={i} className="grid grid-cols-5 gap-4">
              {[...Array(5)].map((_, j) => (
                <Skeleton key={j} className="h-10" />
              ))}
            </div>
          ))}
        </CardContent>
      </Card>

      {/* OrderRecipientGrid skeleton */}
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:items-stretch">
        <Card className="flex flex-col gap-6 p-6 lg:col-span-2 border-0">
          <div className="flex items-center gap-2">
            <Skeleton className="size-5" />
            <Skeleton className="h-6 w-48" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 flex-1">
            {[0, 1].map((card) => (
              <Card key={card} className="rounded-2xl">
                <CardHeader className="p-6">
                  <div className="flex items-center gap-2">
                    <Skeleton className="size-5" />
                    <Skeleton className="h-5 w-40" />
                  </div>
                </CardHeader>
                <CardContent className="p-6 pt-0 space-y-3">
                  {[...Array(4)].map((_, i) => (
                    <div key={i} className="grid grid-cols-[100px_1fr] gap-x-4">
                      <Skeleton className="h-4 w-24" />
                      <Skeleton className="h-4 w-full max-w-xs" />
                    </div>
                  ))}
                </CardContent>
              </Card>
            ))}
          </div>
        </Card>

        <div className="flex flex-col gap-6 h-full">
          {[0, 1].map((card) => (
            <Card key={card} className="flex flex-col flex-1">
              <CardHeader className="p-6 pb-3">
                <div className="flex items-center gap-2">
                  <Skeleton className="size-5" />
                  <Skeleton className="h-5 w-32" />
                </div>
              </CardHeader>
              <CardContent className="flex flex-1 flex-col space-y-3 p-6 pt-0">
                <Skeleton className="h-4 w-24" />
                <div className="h-px bg-border" />
                <Skeleton className="h-14 w-full rounded-lg" />
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
